import api from './client';

export const fetchWorkspaces = (params = {}) => api.get('/admin/workspaces', { params });
export const fetchWorkspace  = (id) => api.get(`/admin/workspaces/${id}`);
